import { render, staticRenderFns } from "./IaoList.vue?vue&type=template&id=57c36a83&scoped=true&"
import script from "./IaoList.vue?vue&type=script&lang=js&"
export * from "./IaoList.vue?vue&type=script&lang=js&"
import style0 from "./IaoList.vue?vue&type=style&index=0&id=57c36a83&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c36a83",
  null
  
)

export default component.exports